(() => {
  const ROW_SELECTOR = '[data-maison-brand-row]';
  const resizeObservers = new WeakMap();

  function stripEditorMetadata(node) {
    if (!(node instanceof Element)) return node;

    node.removeAttribute('data-shopify-editor-block');
    node.removeAttribute('data-shopify-editor-section');
    node.querySelectorAll('[data-shopify-editor-block], [data-shopify-editor-section]').forEach((el) => {
      el.removeAttribute('data-shopify-editor-block');
      el.removeAttribute('data-shopify-editor-section');
    });

    return node;
  }

  function makeDecorativeClone(node) {
    const clone = stripEditorMetadata(node.cloneNode(true));
    clone.setAttribute('aria-hidden', 'true');
    if (clone.matches('a, button, input, select, textarea, [tabindex]')) clone.setAttribute('tabindex', '-1');
    clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((el) => {
      el.setAttribute('tabindex', '-1');
    });
    return clone;
  }

  function fillRow(row) {
    const track = row.querySelector('.maison-brand-track');
    const groups = track ? Array.from(track.querySelectorAll(':scope > .maison-brand-group')) : [];
    if (!track || groups.length < 2 || row.clientWidth <= 0) return;

    const primary = groups[0];
    const duplicate = groups[1];

    // Capture only the merchant-created cards once. Extra cards are decorative copies.
    if (!row._maisonBrandSources) {
      row._maisonBrandSources = Array.from(primary.children).map((node) => node.cloneNode(true));
    }

    const sources = row._maisonBrandSources;
    if (!sources.length) return;

    const style = getComputedStyle(primary);
    const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
    const firstCard = primary.firstElementChild;
    const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : 0;
    // A small buffer means even ultrawide screens never expose the seam during rounding.
    const targetWidth = row.clientWidth + cardWidth + gap;

    let guard = 0;
    while (primary.getBoundingClientRect().width < targetWidth && guard < 100) {
      for (const source of sources) {
        primary.appendChild(makeDecorativeClone(source));
      }
      guard += 1;
    }

    // The second half must be byte-for-byte equivalent in geometry so translateX(-50%)
    // lands on the exact seam. It is decorative and removed from keyboard/AT navigation.
    duplicate.replaceChildren(...Array.from(primary.children).map((node) => makeDecorativeClone(node)));
    duplicate.setAttribute('aria-hidden', 'true');
    duplicate.setAttribute('inert', '');

    row.classList.add('is-ready');
  }

  function initRow(row) {
    fillRow(row);
    if (resizeObservers.has(row) || typeof ResizeObserver === 'undefined') return;

    let raf = 0;
    const observer = new ResizeObserver(() => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => fillRow(row));
    });
    observer.observe(row);
    resizeObservers.set(row, observer);
  }

  function init(scope = document) {
    scope.querySelectorAll(ROW_SELECTOR).forEach(initRow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // Re-initialize when Shopify Theme Editor hot-reloads this section.
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
